<div [class.dropup]="!mobile" [class.dropdown]="mobile">
  <button type="button" class="btn notification-launcher d-flex align-items-center gap-2 position-relative"
          data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" aria-label="Известувања">
    <fa-icon [icon]="faBell" aria-hidden="true" />
    @if (!mobile) { <span>Известувања</span> }
    @if (communication.unread()) {
      <span class="badge rounded-pill bg-danger notification-badge">{{communication.unread() > 99 ? '99+' : communication.unread()}}<span class="visually-hidden"> непрочитани</span></span>
    }
  </button>
  <div class="dropdown-menu dropdown-menu-end notification-preview p-0 rounded-4 shadow border-0">
    <div class="p-3 border-bottom d-flex align-items-center justify-content-between gap-3">
      <strong>Известувања</strong><span class="small text-muted">{{communication.unread()}} непрочитани</span>
    </div>
    <div class="notification-list">
      @if (loading && !items.length) { <p class="p-3 mb-0 text-muted small" role="status">Вчитување…</p> }
      @if (error) { <div class="p-3 small" role="alert">Известувањата не може да се вчитаат. <button class="btn btn-sm primary-outline-btn mt-2" (click)="$event.stopPropagation(); load()">Обиди се повторно</button></div> }
      @if (!loading && !error && !items.length) { <p class="p-4 mb-0 text-muted text-center small">Немате известувања.</p> }
      @for (item of items; track item.id) {
        <a class="dropdown-item notification-item p-3 border-bottom text-wrap" [class.unread]="!item.isRead"
           [routerLink]="item.orderId ? ['/orders'] : item.fileId ? ['/files'] : ['/notifications']"
           [queryParams]="item.orderId ? orderQueryParams(item) : null"
           (click)="markRead(item)">
          <span class="d-block small primary-color fw-semibold mb-1">{{item.kind === 'message' ? 'Порака' : item.kind === 'file' ? 'Датотека' : 'Налог'}}</span>
          <span class="d-block">{{item.title}}</span>
          @if (item.orderNumber) { <span class="d-block small text-muted mt-1">Налог {{item.orderNumber}}</span> }
          <time class="d-block small text-muted mt-1" [attr.datetime]="item.createdAt">{{item.createdAt | appDate:'dateTime':formatting.formats()}}</time>
        </a>
      }
    </div>
    <div class="border-top p-2">
      @if (communication.unread() > 0) {
        <button type="button" class="btn btn-sm w-100 primary-color" [disabled]="markingAll" (click)="$event.stopPropagation(); markAllRead()">{{markingAll ? 'Се означуваат…' : 'Означи сè како прочитано'}}</button>
      }
      @if (readError) { <p class="small text-danger px-2 mb-1" role="alert">Не може да се означат. Обидете се повторно.</p> }
      <a routerLink="/notifications" class="dropdown-item notification-all-link text-center py-2 primary-color fw-semibold rounded-bottom-4">Сите известувања</a>
    </div>
  </div>
</div>
